module.exports = __webpack_public_path__ + "static/media/Latvia.deac029c.png";